var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgCareLogoCircle = function SvgCareLogoCircle(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29.996,
    height: 30,
    viewBox: "0 0 29.996 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6081",
    "data-name": "Group 6081",
    transform: "translate(-0.098 -0.098)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78045",
    "data-name": "Path 78045",
    d: "M16.451,17.871a20.573,20.573,0,0,1,1.248,1.76A16.759,16.759,0,0,1,19.63,17.7a20.37,20.37,0,0,1-1.761-1.25A19.2,19.2,0,0,0,16.451,17.871Zm6.716,1.611a20.16,20.16,0,0,1-2.19-1,15.429,15.429,0,0,0-2.5,2.5,20.147,20.147,0,0,1,1,2.19A13.328,13.328,0,0,1,23.167,19.481ZM14.543,13.12a20.142,20.142,0,0,1-1.249-1.761,16.929,16.929,0,0,1-1.931,1.931,20.342,20.342,0,0,1,1.759,1.25,18.932,18.932,0,0,0,1.42-1.42Zm-3.03-5.295a13.347,13.347,0,0,1-3.687,3.688,20.14,20.14,0,0,1,2.19,1,15.441,15.441,0,0,0,2.5-2.5A20.33,20.33,0,0,1,11.513,7.826ZM29.266,20.8A20.239,20.239,0,0,1,25,20.092a11.85,11.85,0,0,0-4.913,4.913,20.279,20.279,0,0,1,.711,4.262h.106a9.68,9.68,0,0,1,8.357-8.357ZM10.9,5.989a20.309,20.309,0,0,1-.71-4.263h-.106a9.682,9.682,0,0,1-8.357,8.357v.108a20.326,20.326,0,0,1,4.262.71A11.844,11.844,0,0,0,10.9,5.989Z",
    transform: "translate(-0.399 -0.399)",
    fill: "#11616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78046",
    "data-name": "Path 78046",
    d: "M11.867,36.01h-2.1A9.676,9.676,0,0,0,.1,26.345v-2.1A11.778,11.778,0,0,1,11.867,36.011Z",
    transform: "translate(-0.001 -5.914)",
    fill: "#82cece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78047",
    "data-name": "Path 78047",
    d: "M15.433,34.855h-2.1A13.245,13.245,0,0,0,.1,21.623v-2.1a15.349,15.349,0,0,1,15.33,15.332Z",
    transform: "translate(-0.001 -4.757)",
    fill: "#82cece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78048",
    "data-name": "Path 78048",
    d: "M18.992,33.7h-2.1A16.816,16.816,0,0,0,.1,16.9V14.8A18.918,18.918,0,0,1,18.993,33.7Z",
    transform: "translate(0 -3.601)",
    fill: "#82cece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78049",
    "data-name": "Path 78049",
    d: "M36.007,11.867A11.777,11.777,0,0,1,24.243.1h2.1a9.675,9.675,0,0,0,9.665,9.665v2.1Z",
    transform: "translate(-5.913 -0.001)",
    fill: "#fdbe14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78050",
    "data-name": "Path 78050",
    d: "M34.85,15.435A15.35,15.35,0,0,1,19.519.1h2.1A13.246,13.246,0,0,0,34.85,13.335v2.1Z",
    transform: "translate(-4.756 -0.001)",
    fill: "#fdbe14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78051",
    "data-name": "Path 78051",
    d: "M33.694,18.995A18.917,18.917,0,0,1,14.8.1h2.1a16.816,16.816,0,0,0,16.8,16.8Z",
    transform: "translate(-3.6 0)",
    fill: "#fdbe14"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCareLogoCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/care-logo-circle.4c3f1a07.svg";
export { ForwardRef as ReactComponent };